export default __webpack_public_path__ + "static/media/Sansita-Black.cec9e830.ttf";